/* eslint-disable @typescript-eslint/no-explicit-any */

export const createSectionData = (data: any) => {
  const serviceData = data?.data?.maintenance?.map(
    (item: any, index: number) => {
      const value = data?.data?.maintenance?.[
        index
      ]?.new_car_maintenance_description
        ?.replaceAll('</tr>', '')
        ?.replaceAll('<td>', '')
        ?.replace('</tbody></table>', '')
        ?.split('<tr>')
        ?.map((e?: any) => {
          return e
            .split('</td>')
            ?.map((i: any) => (i === '' ? '-' : i))
            ?.slice(0, -1);
        })
        ?.slice(1);

      return {
        name: item.new_car_maintenance_name,
        tableData: value,
      };
    }
  );

  const spec = data?.data?.variant_of_model?.map(
    (item: {
      car_variant_id: number;
      car_model_full_title: string;
      new_car_otr_price: string;
      monthly: string;
      ac_charging_time: string;
      dc_charging_time: string;
      car_variant_name: string;
      car_brand_image: string;
      new_car_highlights: {
        car_seat_number?: number;
        car_body_type_name?: 'string';
        car_variant_cc?: number;
        car_segment_type_name?: 'string';
        car_fuel_type_name?: 'string';
        car_fuel_type_slug?: 'string';
        car_variant_transmission?: 'string';
        engine_model?: 'string';
        kw_hp?: 'string';
        nm_torque?: 'string';
        top_speed?: 'string';
        '0_100_km_h'?: 'string';
        battery_type?: 'string';
        battery_capacity?: 'string';
        charger_type?: 'string';
        ac_charging_time?: 'string';
        dc_charging_time?: 'string';
        ac_max_input?: 'string';
        dc_max_input?: 'string';
        driving_range?: 'string';
      };
    }) => {
      return {
        id: item.car_variant_id,
        model: item.car_model_full_title,
        carTitle: item.car_variant_name,
        price: item.new_car_otr_price,
        monthly: item.monthly,
        ...item.new_car_highlights,
      };
    }
  );

  return { spec, serviceData };
};
